import { useSnapshot } from 'valtio'
import uiState from '../data'
import { motion, AnimatePresence } from 'framer-motion'

const TransitionPage = ({ event }) => {
  const { visible, text } = useSnapshot(uiState[event])

  const opacityVariants = {
    show: {
      opacity: [0.2, 0.4, 0.6, 0.8, 1, 0.8, 0.6, 0.4, 0.2],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        ease: 'linear'
      },
      willChange: 'transform',
      layout: 'position'
    },
    hide: {
      opacity: [0]
    }
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className='fixed top-0 left-0 z-[999] Trajan screen-setting bg-black text-white'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[32px] portraitBigPh:text-[24px] w-full text-center portraitBigPh:whitespace-pre-wrap'
            variants={opacityVariants}
            initial='hide'
            animate='show'
          >
            {text}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default TransitionPage
